<template>
  <div></div>
</template>

<script>
export default {
  name: "PwaSelfCheck",

  mounted() {
    this.checkSwActive();
    setInterval(() => {
      this.checkSwActive();
    }, 8 * 1000);
  },
  methods: {
    checkSwActive() {
      if (navigator.serviceWorker.controller) {
        console.log('Ein aktiver Service Worker steuert die Seite:', navigator.serviceWorker.controller);
        this.$store.commit('swActive', true);

        if(this.$store.getters.isKiosk) {
          swUnregister();
        }
      } else {
        console.log('Kein aktiver Service Worker.');
        this.$store.commit('swActive', false);
      }
    },
  }
}
</script>

<style scoped>

</style>
